

const findItemServices = (containers)=>{
    if(!containers ||containers.length==0){  
      return []; 
    }
    let result =[];
    for(let i=0; i<containers.length; i++ ){
      const container=containers[i];
      const services= findItemsServiceInContainer(container); 
      if(services && services.length>0)
      result= result.concat(services);   
    }
    //console.log('findItemServices',result); 
    return result; 
  }
  
  const findItemsServiceInContainer = (container)=>{
    if(!container 
      || !container.content 
      || !container.content.categories 
      ||container.content.categories.length==0){  
      return []; 
    }
    let result =[]; 
    const categories =container.content.categories; 
    
    for(let i=0; i<categories.length; i++ ){
        const category= categories[i];
        const services= findItemsServiceInCategory(category);
        if(services && services.length>0){
           result= result.concat(services);
           console.log('result',result);    
        }
      }

      //console.log('findItemsServiceInContainer',result); 
      return result; 
  }

  const findItemsServiceInCategory = (category)=>{
    if(!category || !category.items ||category.items.length==0)  
        return []; 
    
    const list = category.items; 
    const result=[]; 
    for(let i=0; i<list.length; i++ ){
      const item= list[i];
      if(item.type=="DELIVERY_SERVICE"){
          result.push(item); 
      }
    }
    //console.log('findItemsServiceInCategory',result); 
    return result; 
  }


  const hasItemServices = (location)=>{
    const list =  findItemServices(location.containers); 
    return list && list.length>0
  }

  const removeServices= (list)=>{
    if(!list || list.length==0)return; 
    let result=[];
    for(let i=0; i<list.length; i++ ){
      const item= list[i];
      if(item.type!="DELIVERY_SERVICE"){
          result.push(item); 
      }
    }
    return result; 
  }


  export {
    hasItemServices, 
    removeServices
   }; 